import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";

export const UserLnbItem = ({path='', lnbCode='', use=true, children})=>{
    const { school } = useParams();

    
    const active = useMemo(()=>{
        if(lnbCode==='')return lnbCode===path;
        
        return path.includes(lnbCode);
    }, [lnbCode, path]);
    

    if(!use)return null;
    return (
        <li className={active?'on':''}>
            <Link to={`/${school}/user${path}`}>{children}</Link>
        </li>
    );
}